import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicConfig } from '@ionic/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { PipesModule } from './pipes/pipes.module';
import { LoggerModule, NGXLogger, NgxLoggerLevel } from 'ngx-logger';
import { DatabaseService } from '@nsk-app/services/database.service';
import { ConfigurationService } from '@nsk-app/services/configuration.service';
import { NotificationService } from '@nsk-app/services/notification.service';
import { sqlite } from '../environments/sqlite';


function asyncProvider(logger: NGXLogger, configuration: ConfigurationService, database: DatabaseService, notificationService: NotificationService){

  return async () => {
    try{
      await configuration.initializeConfiguration();
      await notificationService.initialize();
      await database.initializeDatabase();

      logger.info('Initialized async dependencies.');
    }catch (e) {
      logger.fatal('Could not initialize async dependencies!', e);
    }

  };
}

function getIonicConfig() : IonicConfig{
  const params = (new URLSearchParams(document.location.search));
  const config : IonicConfig = {};

  if(params.has('forceMode')){
    config.mode = params.get('forceMode') == 'ios' ? 'ios' : 'md';

    if(config.mode == 'ios'){
      const style = ':root {--ion-safe-area-top: 30px;--ion-safe-area-bottom: 22px;}';
      const head = document.head || document.getElementsByTagName('head')[0];
      const styleTag : HTMLStyleElement = document.createElement('style');

      head.appendChild(styleTag);
      styleTag.appendChild(document.createTextNode(style));
    }
  }

  if(sqlite.useSqlJs) {
    localStorage.clear();
  }

  return config;
}


@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot(getIonicConfig()),
        LoggerModule.forRoot({ level: NgxLoggerLevel.DEBUG }),
        AppRoutingModule,
        PipesModule
    ],
    providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: APP_INITIALIZER, useFactory: asyncProvider, multi: true, deps: [NGXLogger, ConfigurationService, DatabaseService, NotificationService] }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
